/** Format decimal money strings for display (PKR). */
export function formatMoney(value: string | number, currency = "PKR"): string {
  const amount = typeof value === "number" ? value : Number.parseFloat(value);
  if (!Number.isFinite(amount)) {
    return `${currency} 0.00`;
  }
  return `${currency} ${amount.toLocaleString("en-PK", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatMoneyCompact(value: string | number): string {
  const amount = typeof value === "number" ? value : Number.parseFloat(value);
  if (!Number.isFinite(amount)) {
    return "0";
  }
  if (amount >= 1_000_000) {
    return `${(amount / 1_000_000).toFixed(1)}m`;
  }
  if (amount >= 1_000) {
    return `${(amount / 1_000).toFixed(0)}k`;
  }
  return amount.toFixed(0);
}
